import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { roleValidationForm } from '../../utils/validationSchema';
import Form from '../../layouts/Form';
import RoleForm from './RoleForm';
import { useEffect, useState } from 'react';

const CreateRole = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(roleValidationForm),
  });
  const { handleCreate, isLoading, userPermissions, logesticPermissions } = props;
  const [selectedPermission, setSelectedPermission] = useState([])

  useEffect(() => {
    setValue("custom_permissions", selectedPermission)
  }, [selectedPermission])

  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <RoleForm
        selectedUserPermissions={selectedPermission}
        userPermissions={userPermissions}
        errors={errors}
        register={register}
        setSelectedPermission={setSelectedPermission}
        logesticPermissions={logesticPermissions}
      />
    </Form>
  )
}

export default CreateRole